<template>
    <div class="profile__wrapper">
        <button @click="saveChange">Save Changes</button>
        <form action="">
              <div class="title">Personal Info</div>
              <div class="input__flex__wrapper">
              <InputWrapper>
                    <template #text>
                        First Name
                    </template>
                    <template #input>
                        <Input v-model:value="userData.name"></Input>
                    </template>
                </InputWrapper>
                <InputWrapper>
                    <template #text>
                        Second Name
                    </template>
                    <template #input>
                        <Input v-model:value="userData.second_name"></Input>
                    </template>
                </InputWrapper>
            </div>
            <div class="input__flex__wrapper">
              <InputWrapper>
                    <template #text>
                        email
                    </template>
                    <template #input>
                        <Input v-model:value="userData.email"></Input>
                    </template>
                </InputWrapper>
                <InputWrapper>
                    <template #text>
                        Mobile Phone number
                    </template>
                    <template #input>
                        <VueCountryIntl></VueCountryIntl>
                    </template>
                </InputWrapper>
            </div>
        </form>
        <form action="">
              <div class="title">Change Password</div>
              <div class="input__flex__wrapper">
              <InputWrapper>
                    <template #text>
                        Create password
                    </template>
                    <template #input>
                        <InputPasswordValodation v-model:password="v$.valueField.password.$model"></InputPasswordValodation>
                    </template>
                </InputWrapper>
                <InputWrapper>
                    <template #text>
                        Confirm Password
                    </template>
                    <template #input>
                        <InputPassword v-model:password="v$.valueField.confirmPassword.$model"></InputPassword>
                    </template>
                </InputWrapper>
            </div>
        </form>
        <form action="">
              <div class="title">Address Info</div>
              <InputWrapper>
                    <template #text>
                        Address line
                    </template>
                    <template #input>
                        <Input v-model:value="userData.address.address"></Input>
                    </template>
                </InputWrapper>
            <div class="input__flex__wrapper">
              <InputWrapper>
                    <template #text>
                        Country
                    </template>
                    <template #input>
                        <Select :data_name="'name'" v-model="userData.address.country_id" :selected="userData.country" :sort="countryData" @search="getSearchCountry"></Select>
                    </template>
                </InputWrapper>
                <InputWrapper>
                    <template #text>
                        City
                    </template>
                    <template #input>
                        <Input v-model:value="userData.address.city_name"></Input>
                    </template>
                </InputWrapper>
            </div>
            <div class="input__flex__wrapper">
              <InputWrapper>
                    <template #text>
                        State
                    </template>
                    <template #input>
                        <Input v-model:value="userData.address.state"></Input>
                    </template>
                </InputWrapper>
                <InputWrapper>
                    <template #text>
                        Zip code
                    </template>
                    <template #input>
                        <Input v-model:value="userData.address.zip_code" style="max-width: 136px;"></Input>
                    </template>
                </InputWrapper>
            </div>
        </form>
    </div>
</template>

<script>
import InputWrapper from '../InputWrapper.vue';
import Input from '../Input.vue';
import VueCountryIntl from '@/components/UI/VueCountryIntl.vue';
import InputPassword from '../InputPassword.vue';
import InputPasswordValodation from '../InputPasswordValodation.vue';
import Select from '../Select.vue';
import axios from "axios";
import store from "@/store";
import { useVuelidate } from '@vuelidate/core'
import { required, minLength} from '@vuelidate/validators';
    export default {
        setup: () => ({ v$: useVuelidate() }),
        components: {
            InputWrapper,
            Input,
            VueCountryIntl,
            InputPassword,
            Select,
            InputPasswordValodation
        },
        data() {
            return {
                valueField: {
                    password: '',
                    confirmPassword: '',
                },
                countryData: [],
                userData: this.$store.state.user,
            }
        },
        validations() {
            return {
                valueField: {
                    password: { required, minLength: minLength(8) },
                    confirmPassword: { required, sameAsPassword: this.sameAsPassword },
                }
            }
        },
        methods: {
            sameAsPassword() {
                return this.valueField.confirmPassword === this.valueField.password;
            },
            saveChange(){
                this.updateUser();
                this.v$.$touch();
                if (this.v$.valueField.$invalid) {
                }else{
                    this.changePassword();
                }
            },
            getSearchCountry(e) {
                let fData = new FormData();
                fData.append("name", e);
                axios.post("/user/get-country", fData).then(resp => {
                    if (resp.data['result'] == true) {
                    this.countryData = resp.data.country;
                    }
                }).catch(() => {
                }).finally(() => {
                });
            },
            async updateUser() {
                try {
                    const response = await axios.post('/user/change-user', this.userData);
                    store.commit('setUser', response.data.data)
                } catch (error) {

                }
            },
            async changePassword() {
                try {
                    const formData = new FormData();
                    formData.append('password', this.valueField.password);
                    const response = await axios.post('/user/change-password', formData);
                } catch (error) {
                }
            },
        },
        mounted() {
            this.getSearchCountry('');
        },
        computed: {
            user() {
            return this.$store.state.user;
            },
        }
    }
</script>

<style scoped>
button{
    position: absolute;
    right: 0;
    top: 0;
    height: 32px;
    border-radius: 32px;
    background: rgb(222, 230, 234);
    padding: 0px 24px;
    color: rgb(5, 5, 5);
    font-size: 13px;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0%;
    text-align: center;
}
.input__flex__wrapper{
    display: flex;
    gap: 32px;
    width: 100%;
}
.profile__wrapper{
    max-width: 640px;
    display: flex;
    flex-direction: column;
    gap: 40px;
}
form{
    display: flex;
    flex-direction: column;
    gap: 24px;
}
form .title{
    color: rgb(5, 5, 5);
    font-size: 16px;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0%;
}
@media screen and (max-width: 768px) {
    .input__flex__wrapper{
        flex-direction: column;
    }
}
</style>